import { atom } from 'recoil';
import { TIME_TRAVELLER_ATOM } from './timetravelleratom.action';

export const showDebuggerAtom = atom({
  key: TIME_TRAVELLER_ATOM,
  default: false,
});
